import Icon from '../components/Icon.vue'

Icon.register({"folder":{"width":512,"height":512,"paths":[{"d":"M464 128H272L208 64H48C21.5 64 0 85.5 0 112V400C0 426.5 21.5 448 48 448H464C490.5 448 512 426.5 512 400V176C512 149.5 490.5 128 464 128z"}]}})



// WEBPACK FOOTER //
// ./node_modules/vue-awesome/icons/folder.js